module.exports = __webpack_public_path__ + "img/saibamais.a6b6c335.jpg";